import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(
		auto-fill,
		minmax(270px, 1fr)
	); 
	gap: 24px; 
	width: 100%;

	@media (max-width: 768px) {
		gap: 16px; 
		grid-template-columns: repeat(
			auto-fill,
			minmax(250px, 1fr)

		); 
	}

`;

export const AlbumCard = styled.div`
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	transition: transform 0.3s ease, box-shadow 0.3s ease;
	cursor: pointer;
	position: relative;
	display: flex; 
	flex-direction: column; 

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
	}
`;

export const AlbumThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 4 / 3; 
	background-color: #eee; 
	position: relative;
	overflow: hidden;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AlbumThumbnailImage = styled.img<{ $isLoading: boolean }>`
	width: 100%;
	height: 100%;
	object-fit: cover;
    cursor: pointer;
	display: ${(props) => (props.$isLoading ? 'none' : 'block')};
`;

export const AlbumInfo = styled.div`
	padding: 16px;
	background-color: white;
	display: flex;
	flex-direction: column;

	gap: 8px;
	flex-grow: 1; 

	@media (max-width: 768px) {
		padding: 12px; 

	}
`;

export const AlbumTitle = styled.h3`
	margin: 0;
	font-size: 1rem; 
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	color: var(--color-text-primary, #333);

	@media (max-width: 768px) {
		font-size: 0.95rem; 
	}

`;

export const AlbumDate = styled.p`
	margin: 5px 0 0;
	color: #666;
	font-size: 0.875rem; 

	@media (max-width: 768px) {
		font-size: 0.8rem; 
	}
`;

export const AlbumCount = styled.p`
	margin: 0; 
	color: #666;
	font-size: 0.875rem; 
	text-align: right; 

	@media (max-width: 768px) {
		font-size: 0.8rem; 
	}
`;

// New styled component for the date/count row
export const AlbumMetaRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-top: 5px; 
`;

export const ActionButtons = styled.div`
	position: absolute;
	top: 8px;
	right: 8px;
	display: flex;
	gap: 5px;
`;

export const ActionButton = styled.button`
	background-color: rgba(255, 255, 255, 0.8);
	border: none;
	border-radius: 4px;
	padding: 5px 8px;
	cursor: pointer;
	font-size: 0.75rem; 
	color: #e74c3c; 
	transition: all 0.2s ease;

	&:hover {
		background-color: rgba(255, 255, 255, 1);
		color: #c0392b;
	}

	@media (max-width: 768px) {
		padding: 4px 6px;
		font-size: 0.7rem;
	}
`;

export const EmptyState = styled.div`
	width: 100%;
	padding: 40px;
	text-align: center;
	background-color: #f9f9f9;
	border-radius: 8px;
	margin-top: 20px;
`;

export const CreateAlbumButton = styled(Link)`
	display: inline-block;
	margin-top: 20px;
	padding: 10px 20px;
	background-color: var(--color-accent, #007bff);
	color: white;
	text-decoration: none;
	border-radius: 5px; 
	font-weight: 500; 
	font-size: 0.95rem;
	transition: background-color 0.2s ease, transform 0.1s ease;

	&:hover {
		background-color: var(--color-accent-dark, #0056b3);
		transform: translateY(-1px);
	}
	&:active {
		transform: translateY(0);
	}

	@media (max-width: 768px) {
		padding: 8px 16px;
		font-size: 0.9rem;
	}
`;

export const PseudoAlbumCard = styled.div`
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	padding: 20px;
	gap: 12px;
	min-height: 200px;
	justify-content: flex-end;

	&:hover {
		transform: translateY(-5px);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
	}

	span {
		font-size: 1.1rem;
		font-weight: 600;
	}
`;

export const SchoolYearSeparator = styled.div`
	grid-column: 1 / -1;
	display: flex;
	align-items: center;
	gap: 14px;
	margin-top: 14px;

	&:first-child {
		margin-top: 4px;
	}

	span {
		font-weight: 600;
		font-size: 1.05rem;
		color: #3a5a86;
		white-space: nowrap;
	}

	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background: rgba(58, 90, 134, 0.25);
	}
`;
